<script lang="ts">
import { version } from 'vue'
import vue2Dropzone from 'vue2-dropzone'

const VueDropzone = vue2Dropzone

if (version.startsWith('3.')) {
  // @TODO: Uncomment this when vue2-dropzone-vue3 is updated to support Vue 3
  // We need to run `yarn add vue2-dropzone-vue3` to install the package
  // https://www.npmjs.com/package/vue2-dropzone-vue3
  throw new Error('Vue 3 is not supported')
}

export default {
  functional: true,
  render(h, context) {
    if (!VueDropzone) return null

    return h(
      VueDropzone,
      {
        props: context.props,
        on: context.listeners,
        attrs: context.data.attrs,
        scopedSlots: context.scopedSlots,
        class: context.data.class,
        staticClass: context.data.staticClass,
        staticStyle: context.data.staticStyle,
        style: context.data.style,
        directives: context.data.directives,
        domProps: context.data.domProps,
        ref: context.data.ref,
        key: context.data.key,
        nativeOn: context.data.nativeOn,
      },
      context.children,
    )
  },
}
</script>
